<template>
  <div class="item">
    <div class="foto">
      <img :src="clinic.logo" :alt="clinic.name" @error="handleImageError" />
    </div>
    <div class="nome">
      <h3>{{ clinic.name }}</h3>
      <p>Profesional acreditado</p>
    </div>
    <button @click="$emit('agendar', clinic)">Agendar una cita</button>
  </div>
</template>

<script setup>
const defaultImage = 'https://firebasestorage.googleapis.com/v0/b/system-oligocheck.appspot.com/o/clinics%2F1757882609228_SOCHECK.jpeg?alt=media&token=6b02c18c-cc05-4d35-a4c3-f3074e6b4c3f';

defineProps({
  clinic: {
    type: Object,
    required: true
  }
})
defineEmits(['agendar'])

const handleImageError = (event) => {
  event.target.src = defaultImage;
};
</script>

<style scoped>
.item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: #F3F8FA;
  border-radius: 10px;
  padding: 25px 25px 80px 25px;
  position: relative;
  width: 320px;
  min-width: 320px;
  max-width: 320px;
  margin: 0 20px 0 0;
  border: 1px solid #e0e0e035;
}
.item .foto {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 55px;
  height: 55px;
  border-radius: 50%;
}
.item .foto img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #2280b4;
}
.item button {
  font-family: var(--bold);
  font-size: var(--f2);
  color: var(--cor-branco);
  padding: 20px 0;
  text-align: center;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #2280b4;
  border-radius: 10px;
  transition: all 0.3s;
}
.item button:hover {
  background-color: #103e7f;
}
.item .nome {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 0 0 15px;
}
.item .nome h3 {
  font-family: var(--bold);
  font-size: var(--f2);
  color: var(--cor-preto);
  word-break: break-word;
  hyphens: auto;
}
.item .nome p {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-preto);
  margin: 5px 0 0 0;
}
</style> 